module.exports = __webpack_public_path__ + "img/btn_sure.284d3bae.png";